import { EntityImageManager } from '@/components/entity-image-manager';
import { useSubscription } from '@/hooks/useSubscription';
import type { Character, ProcessedImage } from '@/lib/types';

interface ImageManagerProps {
  onUpdate: (updates: { images?: ProcessedImage[], pendingFiles?: File[], primaryImageId?: string | null }) => void;
  character: Character;
  pendingFiles?: File[];
  isProcessing?: boolean;
  visualDescription?: string;
  onVisualDescriptionChange?: (value: string) => void;
  disableDeletion?: boolean;
}

export function ImageManager({
  onUpdate,
  character,
  pendingFiles,
  isProcessing = false,
  visualDescription,
  onVisualDescriptionChange,
  disableDeletion
}: ImageManagerProps) {
  const { hasFeature, isTokenDepleted } = useSubscription();
  const canCreateAIImages = hasFeature('can_create_ai_images');

  return (
    <EntityImageManager
      type="characters"
      images={character.images || []}
      primaryImageId={character.primaryImageId ?? null}
      onUpdate={onUpdate}
      pendingFiles={pendingFiles}
      isProcessing={isProcessing}
      entityId={character.id}
      canCreateAIImages={canCreateAIImages}
      isTokenDepleted={isTokenDepleted}
      visualDescription={visualDescription}
      onVisualDescriptionChange={onVisualDescriptionChange}
      disableDeletion={disableDeletion}
    />
  );
}
